// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"748c8fd1","104":"1aa66466","174":"eeabac37","189":"5ff54040","204":"8999d99a","623":"5d3e48d8","673":"3957b08b","815":"ae9b7e5d","852":"3e00ff43","858":"258d2a52","876":"07173e99","898":"5d4f37ea","909":"c42e3dfb"}[chunkId] + ".chunk.js";
};